var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center progress-status",style:({
    '--status-color': _vm.statusConfig.color,
  }),attrs:{"data-cy":"progress-status"}},[_c('v-icon',[_vm._v("$"+_vm._s(_vm.statusConfig.icon))]),_vm._v(" "+_vm._s(_vm.statusConfig.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }